export const facebookStatisticsFilters = [
  {
    label: 'Общие',
    options: [
      {value: 'state', label: 'Состояние'},
      {value: 'type', label: 'Источник'},
    ],
  },
  {
    label: 'Influence',
    options: [
      {value: 'inf_traffic_id', label: 'Блогер'},
      {value: 'inf_link_id', label: 'INF Поток'},
      {value: 'inf_bayer_id', label: 'INF Байер'},
    ],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'fb_traffic_id', label: 'Кампания'},
      {value: 'fb_link_id', label: 'FB Поток'},
      {value: 'pixel_id', label: 'Пиксель'},
      {value: 'fb_bayer_id', label: 'FB Байер'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'advertiser_id', label: 'Рекламодатель'},
      {value: 'brand_id', label: 'Бренд'},
      {value: 'country_id', label: 'ГЕО'},
      {value: 'offer_id', label: 'Оффер'},
      {value: 'landing_id', label: 'Лендинг'},
    ],
  },
  {
    label: 'Приложения',
    options: [
      {value: 'app_id', label: 'Приложение'},
      {value: 'app_service_id', label: 'Сервисы', isSearch: false},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot_id', label: 'Бот'},
      {value: 'channel_id', label: 'Канал'},
      {value: 'tg_account_id', label: 'Телеграм Аккаунт'},
      {value: 'channel_group_id', label: 'Группа Каналов'},
    ],
  },
];
